































































































































































































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';
import { gruposIds, tipoPartoStrings } from '../../utils/constants';
import { getDpp, ocorrenciasPartoString } from '../../utils/functions';

import { Acompanhamento, TipoParto } from '../../../../back/src/types';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Internacao } from '../../../../back/src/entity/Internacao';

import CustomDialog from '../CustomDialog.vue';
import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import TheGestacoesDadosFinalizada from './TheGestacoesDadosFinalizada.vue';
import { Usuario } from '../../../../back/src/entity/Usuario';
import { Parto } from '../../../../back/src/entity/Parto';

export default Vue.extend({
  name: 'TheGestacoesTabelaNascidos',
  components: {
    CustomDialog,
    IfEmptyTextPrintNA,
    TheGestacoesDadosFinalizada,
  },
  props: {
    acompanhamento: {
      type: String as () => Acompanhamento,
      default: '',
    },
    responsavelId: {
      type: null || Number,
      default: null,
    },
  },
  data() {
    return {
      loading: {
        table: true,
        usuarios: true,
      },
      search: '',
      lastSearch: '',
      options: {
        itemsPerPage: 30,
      },
      totalRegistros: 0,
      gestacoes: [] as Gestacao[],
      dialogDetalhes: false,
      gestacaoSelecionada: null,
      usuarios: [],
      filterResponsavelParticular: null,
      Acompanhamento,
    };
  },
  computed: {
    headers() {
      const headers = [
        {
          value: 'paciente.nome',
          text: 'Nome',
          class: 'text-no-wrap',
          sortable: false,
        },
      ];
      if (this.acompanhamento === Acompanhamento.PARTICULAR) {
        headers.push({
          value: 'paciente.responsavel.nome',
          text: 'Responsável',
          class: 'text-no-wrap',
          sortable: false,
        });
      }
      return headers.concat([
        {
          value: 'tipo_parto',
          text: 'Via de parto',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'dpp',
          text: 'DPP',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'data_parto',
          text: 'Data do parto',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'paciente.paridade',
          text: 'Paridade',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'local_parto',
          text: 'Local',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'ocorrencias',
          text: 'Ocorrências',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'observacoes',
          text: 'Observações',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'endereco',
          text: 'Endereço',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'telefone',
          text: 'Telefone',
          class: 'text-no-wrap',
          sortable: false,
        },
      ]);
    },
    numPaginas() {
      if (this.totalRegistros === 0) {
        return 1;
      }
      return Math.ceil(this.totalRegistros / this.options.itemsPerPage);
    },
    usuariosItens() {
      return _.orderBy(
        _.map(
          _.filter(
            this.usuarios as Usuario[],
            usuario => !usuario.email.includes('@kemiocode'),
          ),
          usuario => ({ value: usuario.id, text: usuario.nome }),
        ),
        ['text'],
      );
    },
  },
  mounted() {
    if (this.acompanhamento === Acompanhamento.PARTICULAR) {
      this.buscaUsuarios();
    }
  },
  methods: {
    gestacaoFinalizadaAtualizada(gestacao: Gestacao) {
      (this as Vue
        & { dialogDetalhes: boolean }).dialogDetalhes = false;
      (this as Vue & { carregaNovaPagina: Function }).carregaNovaPagina();
    },
    realizaBusca() {
      if ((this as Vue
        & { lastSearch: string }).lastSearch !== (this as Vue & { search: string }).search) {
        (this as Vue & { lastSearch: string }).lastSearch = (this as Vue
          & { search: string }).search;
        (this as Vue & { carregaNovaPagina: (search: string) => void }).carregaNovaPagina(
          (this as Vue & { lastSearch: string }).lastSearch,
        );
      }
    },
    getInternacaoAtivaId(gestacaoId: number, internacoes: Internacao[]) {
      const internacaoAtiva = _.find(
        internacoes,
        internacao => (
          internacao.gestacao_id === gestacaoId
          && !internacao.data_alta
          && !internacao.cancelled
        ),
      );
      return _.get(internacaoAtiva, 'id', null);
    },
    getDpp(gestacao: Gestacao) {
      return getDpp(gestacao);
    },
    tipoPartoString(tipoParto: TipoParto) {
      return _.get(tipoPartoStrings, tipoParto, null);
    },
    ocorrenciasParto(parto: Parto) {
      return ocorrenciasPartoString(parto);
    },
    async carregaNovaPagina(search = '') {
      (this as Vue & { loading: { table: boolean } }).loading.table = true;
      (this as Vue & { gestacoes: Gestacao[] }).gestacoes = [];
      // options tipo
      const queryObj: any = {
        pagina: (this as Vue & { options: { page: number } }).options.page,
        itens_por_pagina: (this as Vue
          & { options: { itemsPerPage: number } }).options.itemsPerPage,
        acompanhamento: (this as Vue & { acompanhamento: Acompanhamento }).acompanhamento,
        responsavelId: (this as Vue
          & { filterResponsavelParticular: number }).filterResponsavelParticular,
        search,
      };
      try {
        const response = await Requester.gestacao.buscaGestacoesFinalizadas(queryObj);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          (this as Vue & { gestacoes: Gestacao[] }).gestacoes = response.data.registros;
          (this as Vue & { totalRegistros: number }).totalRegistros = response.data.total_registros;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        (this as Vue & { loading: { table: boolean } }).loading.table = false;
      }
    },
    async buscaUsuarios() {
      (this as Vue & { loading: { usuarios: boolean } }).loading.usuarios = true;
      try {
        const response = await Requester.usuario.usuarios({
          grupo_id: [
            gruposIds.MÉDICAS,
            gruposIds.DIREÇÃO,
            gruposIds.OBSTETRIZES,
          ],
          ativo: 'true',
        });
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          (this as Vue & { usuarios: Usuario[] }).usuarios = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        (this as Vue & { loading: { usuarios: boolean } }).loading.usuarios = false;
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.carregaNovaPagina(this.lastSearch);
      },
      deep: true,
    },
  },
});
